import { formatQuotedPrice } from "@shared-core/domain/formatters";
import type { QuantityStepUp } from "@shared-core/domain/quantity-step-up";
import { TrendingDown } from "lucide-react";

// The upsell under the quantity ladder: what the next tier up costs extra and
// what each unit then costs, shown together. One click selects that tier.
export function QuantityStepUpNudge({
  stepUp,
  onSelect,
}: {
  stepUp: QuantityStepUp;
  onSelect: (quantity: number) => void;
}) {
  const quantity = stepUp.quantity.toLocaleString("en-GB");
  const unitComparison = `${formatQuotedPrice(stepUp.unitPricePence)} each instead of ${formatQuotedPrice(stepUp.currentUnitPricePence)}`;

  return (
    <button
      type="button"
      onClick={() => onSelect(stepUp.quantity)}
      className="flex w-full items-start gap-3 rounded-lg border border-dashed border-primary/50 bg-primary/5 px-3.5 py-3 text-left text-sm outline-none transition-colors hover:bg-primary/10 focus-visible:ring-[3px] focus-visible:ring-ring/50"
    >
      <TrendingDown className="mt-0.5 size-4 shrink-0 text-primary" />
      <span>
        <span className="font-medium">
          Make it {quantity}{" "}
          {stepUp.extraPence === 0 ? (
            "for the same price"
          ) : (
            <>
              for{" "}
              <span className="tabular-nums">
                {formatQuotedPrice(Math.abs(stepUp.extraPence))}
              </span>{" "}
              {stepUp.extraPence > 0 ? "more" : "less"}
            </>
          )}
        </span>
        <span className="text-muted-foreground tabular-nums">
          {" "}
          — {unitComparison}
        </span>
      </span>
    </button>
  );
}
